import { ButcherHeader } from '@components/ButcherHeader';
import { SideNav } from '@components/OrderCreation/OrderSideNav';
import { OrderListBreadcrumbs } from '@components/OrderProcessing/OrderListBreadcrumbs';
import {
  AppSettingsAboutApplicationSteps,
  OrderProcessingMasterData,
} from '@helpers/Constants';

export const AboutApplication: React.FC = () => {
  const BreadCrumbsProps = {
    steps: AppSettingsAboutApplicationSteps,
    activeItem: 'About Application',
    type: OrderProcessingMasterData.APP_SETTINGS,
  };

  return (
    <div className="flex h-screen w-screen gap-1">
      {/* Sidebar */}
      <SideNav active={10} />
      {/* Main Content */}
      <div className="flex-1 p-1 overflow-auto relative">
        {/* Header */}
        <ButcherHeader />
        <OrderListBreadcrumbs orderInfo={BreadCrumbsProps} />
        <div className="p-3">
          {/* Title section */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2 text-gray-700">
              <button
                type="button"
                onClick={() => window.history.back()}
                className="p-1"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289L9.29289 1.29289C9.68342 0.902369 10.3166 0.902369 10.7071 1.29289C11.0976 1.68342 11.0976 2.31658 10.7071 2.70711L6.41421 7L10.7071 11.2929C11.0976 11.6834 11.0976 12.3166 10.7071 12.7071Z"
                    fill="#1C1B1F"
                  />
                </svg>
              </button>
              <h2 className="text-xl font-semibold text-[#1C1B1F]">
                About Application
              </h2>
            </div>
          </div>

          {/* Main Content */}
          <div className="border border-[#0000001F] p-4 rounded-lg">
            <div className="flex flex-row">
              {/* Info Icon */}
              <span className="mt-1">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                    fill="black"
                  />
                </svg>
              </span>
              <span className="ml-2 text-xl font-medium text-[#000A16]">
                What is Wild Game Butcher?
              </span>
            </div>
            {/* Content */}
            <div className="mt-5">
              <p className="font-medium text-[#555F71] text-lg">
                The Wild Game Butcher (WGB App) is a comprehensive and
                user-friendly platform designed to help butcher houses
                streamline their operations and improve efficiency. It supports
                the entire lifecycle of wild game meat processing, including
                customer onboarding, hunting license management, meat
                processing, packaging, and order delivery.
              </p>

              <p className="text-[#555F71] font-medium text-lg">
                The system allows butcher shops to offer customized services,
                enabling customers to Select specific cuts, preparations,
                add-ons, packaging options and Animal Mount Cape, Hide Tanning
                through an intuitive interface
              </p>

              <p className="mt-6 text-[#555F71] font-medium text-lg">
                By automating key workflows, the WGB App reduces manual errors,
                enhances productivity, and ensures a seamless experience for
                both staff and customers. It also ensures data privacy and
                facilitates smooth communication through integrated payment
                gateways and real-time notifications. The main goal of the WGB
                App is to make daily operations easier and more efficient for
                butcher houses, enabling them to focus on delivering
                high-quality service and growing their business effectively.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
